import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './styles.scss';

const CheckboxIcon = ({ customStyle, checked }) => {
    const checkMarkColor = customStyle?.backgroundColor || '#FFFFFF';
    const checkMarkSquareBorderColor = customStyle?.color || (checked ? '#007aff' : '#c7c7cc');
    const checkMarkSquareFillColor = checked ? (customStyle?.color || '#007aff') : 'transparent';

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
            <rect className={styles.checkMarkSquare} x="0.75" y="0.75" width="16.5" height="16.5" rx="6"
                ry="6" strokeWidth="1.5px"
                fill={checkMarkSquareFillColor}
                stroke={checkMarkSquareBorderColor} />
            <path className={styles.checkMark}
                d="M5.35,8.89a.48.48,0,0,0-.71,0,.57.57,0,0,0,0,.76l2.5,2.69a.48.48,0,0,0,.71,0l5.5-5.92a.57.57,0,0,0,0-.76.48.48,0,0,0-.71,0L7.5,11.2Z"
                fill={checkMarkColor}
                stroke={checkMarkColor} />
        </svg>
    );
};

CheckboxIcon.propTypes = {
    customStyle: PropTypes.object,
    checked: PropTypes.bool,
};

const Checkbox = ({
    className,
    hasError,
    placeholder,
    styled,
    disabled,
    builderInput,
    style,
    checked,
    ...rest
}) => (
    <label
        className={classNames(
            className,
            styles.root,
            styles[styled],
            hasError && styles.error,
            disabled && styles.disabled,
            builderInput && styles.builderInput,
            checked && styles.checked
        )}
    >
        <div className={styles.wrap}>
            <input className={styles.input} type="checkbox" disabled={disabled} checked={checked} {...rest} />

            {styled === 'toggle' ? (
                <div className={styles.toggler} />
            ) : (
                <CheckboxIcon customStyle={style} checked={checked} />
            )}
        </div>
        {placeholder && <div className={styles.label}>{placeholder}</div>}
    </label>
);

Checkbox.propTypes = {
    className: PropTypes.string,
    placeholder: PropTypes.any,
    hasError: PropTypes.bool,
    disabled: PropTypes.bool,
    styled: PropTypes.oneOf(['default', 'toggle']),
    builderInput: PropTypes.bool,
    style: PropTypes.object,
    checked: PropTypes.bool,
};

Checkbox.defaultProps = {
    hasError: false,
    disabled: false,
    styled: 'default',
    builderInput: false,
    checked: false,
};

export default Checkbox;
